import React from 'react';
import PrintBulletinHeader from './PrintBulletinHeader';
import PrintStudentInfo from './PrintStudentInfo';
import PrintGradesTable from './PrintGradesTable';
import PrintClassStatistics from './PrintClassStatistics';
import PrintDecisionConseil from './PrintDecisionConseil';
import PrintQRCode from './PrintQRCode';

const BulletinPrintZone = ({ 
  printingBulletin, 
  etablissement, 
  tableauHonneur, 
  printRef 
}) => {
  if (!printingBulletin || !etablissement) {
    return null;
  }

  return (
    <div ref={printRef} className="hidden" style={{ position: 'relative' }}>
      <PrintBulletinHeader 
        etablissement={etablissement} 
        anneeAcademique={printingBulletin?.annee_academique}
        semestre={printingBulletin?.semestre}
      />
      <PrintStudentInfo 
        etudiant={printingBulletin?.etudiant} 
        classe={printingBulletin?.classe}
        bulletin={printingBulletin}
      />
      <PrintGradesTable 
        details={printingBulletin?.details} 
        moyenneSemestre={printingBulletin?.moyenne_semestre}
      />
      
      {/* Statistiques et Décision côte à côte */}
      <div style={{ 
        display: 'flex', 
        gap: '12px', 
        marginBottom: '8px',
        alignItems: 'flex-start'
      }}>
        <div style={{ flex: '1', minWidth: '0' }}>
          <PrintClassStatistics 
            moyenneSemestre={printingBulletin?.moyenne_semestre}
          />
        </div>
        <div style={{ 
          width: '1px', 
          backgroundColor: '#000', 
          height: '100%',
          margin: '0 4px'
        }}></div>
        <div style={{ flex: '1', minWidth: '0' }}>
          <PrintDecisionConseil 
            tableauHonneur={tableauHonneur}
          />
        </div>
      </div>
      
      {/* QR Code avec informations clés */}
      <PrintQRCode 
        bulletin={printingBulletin}
        etablissement={etablissement}
      />
    </div>
  );
};

export default BulletinPrintZone;
